import { DatePickerInput, DateValue } from '@mantine/dates';
import { Calendar } from 'lucide-react';
import { FC } from 'react';

import PractitionerSelect from '@/components/Filtering/PractitionerSelect.tsx';
import RoomSelect from '@/components/Filtering/RoomSelect.tsx';
import TextFilter from '@/components/Filtering/TextFilter.tsx';

import { useFilterStore } from '@/stores/filterStore.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface Props {
    config?: {
        disablePast?: boolean;
    };
}

const FilterHeader: FC<Props> = ({ config = { disablePast: true } }) => {
    const { search_text, date } = useFilterStore();

    const setDateLogic = (date: DateValue): void => {
        useFilterStore.setState({ date: date ? new Date(date) : undefined });
    };

    return (
        <div className="flex gap-5">
            <TextFilter
                placeholder="Name, Geburtstagsdatum, Email, Patientennummer"
                value={search_text}
                onChange={(value) => useFilterStore.setState({ search_text: value })}
            />
            <PractitionerSelect />
            <RoomSelect />
            <DatePickerInput
                highlightToday
                value={date}
                onChange={setDateLogic}
                rightSection={<Calendar className="size-6" />}
                locale="de"
                rightSectionPointerEvents="none"
                className="w-48"
                minDate={config.disablePast ? dayjs().toDate() : undefined}
            />
        </div>
    );
};

export default FilterHeader;
